import { Controller } from "@hotwired/stimulus";

// Garde le bouton d'envoi désactivé tant qu'aucune option n'est choisie dans
// la liste — et donc sa confirmation (data-turbo-confirm) fermée.
//
// Remplace l'attribut « required » quand la liste est habillée par SlimSelect :
// la liste native est alors masquée, et le navigateur, qui ne peut pas y
// afficher son message, bloque l'envoi sans rien dire.
//
//   <form data-controller="require-choice">
//     <select data-require-choice-target="select"
//             data-action="change->require-choice#update">…</select>
//     <button data-require-choice-target="submit">…</button>
//   </form>
export default class extends Controller {
  static targets = ["select", "submit"];

  connect() {
    this.update();
  }

  update() {
    this.submitTarget.disabled = !this.selectTarget.value;
  }
}
